import { ValidatorFn, Validators } from '@angular/forms'
import { MAX_SQL_INT } from '@helios/utils'

export const IntegerIdValidator = Validators.compose([
  Validators.min(0),
  Validators.max(MAX_SQL_INT),
  Validators.pattern(/^[0-9]+$/),
]) as ValidatorFn
